/**
 * Canonical list of public indexable paths (no locale prefix).
 * Used by the human sitemap page and generate-sitemap.mjs.
 */
export const SITEMAP_MAIN_PATHS = [
  '/',
  '/about',
  '/team',
  '/contact',
  '/services',
  '/therapy-modality',
  '/resources',
  '/careers',
  '/emdr',
  '/sliding-scale',
  '/groups',
  '/locations',
  '/modalities-rates',
  '/services-investment',
  '/intake',
  '/sms-privacy-policy',
  '/sms-terms',
  '/sitemap'
]

export const SITEMAP_TEAM_SLUGS = [
  'lidiana-cartolano',
  'victoria',
  'karina',
  'paula',
  'liz',
  'julia'
]

/** Therapeutic group detail pages */
export const SITEMAP_GROUP_SLUGS = [
  'cade-o-manual',
  'conectados',
  'mood-lab'
]

/** Home single-page section IDs (hash links on /) */
export const SITEMAP_HOME_SECTION_HASHES = [
  'home',
  'emdr',
  'team',
  'conditions-we-treat',
  'our-office',
  'faq',
  'contact'
]
